var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.72,
    height: 17.28,
    viewBox: "0 0 18.72 17.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-433.592 -242.15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.038,6.378a.441.441,0,0,1,0-.358A9.749,9.749,0,0,1,8.856,0a9.749,9.749,0,0,1,8.818,6.02.441.441,0,0,1,0,.358A9.749,9.749,0,0,1,8.856,12.4,9.749,9.749,0,0,1,.038,6.378Z",
    transform: "translate(434.096 246.532)",
    fill: "none",
    stroke: "#0c4767",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.657,5.314A2.657,2.657,0,1,1,5.314,2.657,2.657,2.657,0,0,1,2.657,5.314Z",
    transform: "translate(440.295 250.075)",
    fill: "none",
    stroke: "#fd9926",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.118,4.225l-.742-.469L15.315.845l.742.469L14.119,4.225h0Zm-12.18,0h0L0,1.314.742.845,2.68,3.757l-.742.469Zm5.6-.845V0h.892V3.38Z",
    transform: "translate(434.987 242.15)",
    fill: "#fd9926"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye_icon.f81316c0387acf985666fefda78b9eaf.svg";
export { ForwardRef as ReactComponent };